import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KeyCodes_instancevfnkc2xsbiba as KeyCodes_instance } from '../../models/KeyCode.commonHtml.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { FutureElement3o36ukl4wk2br as FutureElement } from '../RView.commonHtml.js.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ToggleButton$lambda(it) {
  if (!(it instanceof KeyboardEvent))
    THROW_CCE();
  if (it.code === KeyCodes_instance.fax() || it.code === KeyCodes_instance.gax()) {
    it.preventDefault();
  }
  return Unit_instance;
}
function ToggleButton$checked$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  var tmp = $this$vprop.zb3_1.ib7_1.checked;
  return ((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true;
}
function ToggleButton$checked$lambda_0($this$vprop, value) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  $this$vprop.zb3_1.ib7_1.checked = value;
  return Unit_instance;
}
var ToggleButtonClass;
function ToggleButton() {
  if (ToggleButtonClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (FutureElement())();
        this.jba(this.ob6_1.ybe(ClickableSemantic_getInstance()));
        this_0.xb3_1 = 'input';
        var tmp0 = this_0.zb3_1;
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value = 'checkbox';
        tmp0.ib7_1.type = value;
        this_0.hb4_1.v('checkResponsive');
        this_0.hb4_1.v('kui');
        // Inline function 'com.lightningkite.kiteui.views.hidden' call
        this_0.zb3_1.ib7_1.hidden = true;
        // Inline function 'com.lightningkite.kiteui.views.display' call
        this_0.bb4_1.fb7_1.display = 'none';
        tmp.mcq_1 = this_0;
        this.tb5_1.xb3_1 = 'label';
        this.tb5_1.hb4_1.v('kiteui-stack');
        this.tb5_1.hb4_1.v('checkResponsive');
        this.tb5_1.hb4_1.v('clickable');
        // Inline function 'com.lightningkite.kiteui.views.tabIndex' call
        this.tb5_1.zb3_1.ib7_1.tabIndex = 0;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_1 = this.tb5_1;
        var tmp0_safe_receiver = this_1.vb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp0_safe_receiver.addEventListener('keydown', ToggleButton$lambda);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          // Inline function 'kotlin.run' call
          var tmp_1 = this_1.eb4_1['on' + 'keydown'];
          var old = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
          var tmp_2 = 'on' + 'keydown';
          this_1.eb4_1[tmp_2] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.fax() || it.code === KeyCodes_instance.gax()) {
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_2 = this.tb5_1;
        var tmp0_safe_receiver_0 = this_2.vb3_1;
        var tmp_3;
        if (tmp0_safe_receiver_0 == null) {
          tmp_3 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener('keyup', (it) => {
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.fax() || it.code === KeyCodes_instance.gax()) {
              this.mcq_1.ac9();
              it.preventDefault();
            }
            return Unit_instance;
          });
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          // Inline function 'kotlin.run' call
          var tmp_4 = this_2.eb4_1['on' + 'keyup'];
          var old_0 = (!(tmp_4 == null) ? typeof tmp_4 === 'function' : false) ? tmp_4 : null;
          var tmp_5 = 'on' + 'keyup';
          this_2.eb4_1[tmp_5] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            if (!(it instanceof KeyboardEvent))
              THROW_CCE();
            if (it.code === KeyCodes_instance.fax() || it.code === KeyCodes_instance.gax()) {
              this.mcq_1.ac9();
              it.preventDefault();
            }
            return Unit_instance;
          };
        }
        this.tb5_1.zbt(this.mcq_1);
        var tmp_6 = this;
        var tmp_7 = ToggleButton$checked$lambda;
        tmp_6.ncq_1 = vprop(this.mcq_1, 'input', tmp_7, ToggleButton$checked$lambda_0);
        this.ncq_1.tah(() => {
          if (this.ncq_1.f2())
            this.tb5_1.hb4_1.v('checked');
          else
            this.tb5_1.hb4_1.w3('checked');
          return Unit_instance;
        });
      }
      ub9(index, view) {
        super.ub9(index, view);
        Companion_instance.lbg(this, index, view);
      }
    }
    initMetadataForClass($, 'ToggleButton');
    ToggleButtonClass = $;
  }
  return ToggleButtonClass;
}
//region block: exports
export {
  ToggleButton as ToggleButton22qnd3p3jsqqx,
};
//endregion

//# sourceMappingURL=ToggleButton.commonHtml.mjs.map
